import Entity from './entities/Entity'
import App from './entities/App'
import Module from './entities/Module'
import DOMInteractModule from './entities/DOMInteractModule'

export default {
  Entity,
  App,
  Module,
  DOMInteractModule,
}
